import type { Rng } from '../types'

export function mulberry32(seed: number): Rng {
	let a = seed >>> 0
	return () => {
		a = (a + 0x6d2b79f5) | 0
		let t = Math.imul(a ^ (a >>> 15), 1 | a)
		t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296
	}
}

/** Standard normal via Box-Muller. Consumes two rng draws. */
export function gaussian(rng: Rng): number {
	const u = Math.max(rng(), 1e-12)
	const v = rng()
	return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v)
}
